export default "__VITE_ASSET__BEH9sboT__"